"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFormatAsin = void 0;
const ASIN_REGEX = /^[0-9]{9}[0-9X]$|^[A-Z][A-Z0-9]{9}$/i;
const isValidFormatAsin = (asin) => ASIN_REGEX.test(asin);
exports.isValidFormatAsin = isValidFormatAsin;
